import { HttpMethods, restRequest } from 'common-src/features/rest';

export const getPatientIntegrationsAthenaRequest = (query, params) =>
  restRequest({
    uri: 'patientIntegrationsAthena',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const createPatientIntegrationsAthena = (body, params) =>
  restRequest({
    uri: 'patientIntegrationsAthena',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const updatePatientIntegrationsAthena = (body, params) =>
  restRequest({
    uri: `patientIntegrationsAthena/${body.id}`,
    method: HttpMethods.Patch,
    body,
    ...params,
  });

export const deletePatientIntegrationsAthena = (id, params) =>
  restRequest({
    uri: `patientIntegrationsAthena/${id}`,
    method: HttpMethods.Delete,
    ...params,
  });

export const sendMocaResultsToAthena = (patientId, params) =>
  restRequest({
    uri: `athena/documents/${patientId}/moca`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const getBookedAppointmentsFromAthena = (query, params) =>
  restRequest({
    uri: 'athena/appointments/booked',
    method: HttpMethods.Get,
    query,
    ...params,
  });

export const getAppointmentDetailsFromAthena = (athenaAppointmentId, params) =>
  restRequest({
    uri: `athena/appointments/details/${athenaAppointmentId}`,
    method: HttpMethods.Get,
    ...params,
  });

export const getPatientFromAthena = (athenaPatientId, practiceId, params) =>
  restRequest({
    uri: `athena/patient/${athenaPatientId}/${practiceId}`,
    method: HttpMethods.Get,
    ...params,
  });

export const getAthenaAppointmentVisits = (patientId, params) =>
  restRequest({
    uri: `athena/appointments/visits/${patientId}`,
    method: HttpMethods.Get,
    ...params,
  });

export const createPatientOnAthena = (patientId, practiceId, departmentId, params) =>
  restRequest({
    uri: `athena/patients/${patientId}`,
    method: HttpMethods.Post,
    query: { practice_id: practiceId, department_id: departmentId },
    ...params,
  });

export const updateAthenaPatientDemographics = (patientId, params) =>
  restRequest({
    uri: `athena/patients/${patientId}/demographics`,
    method: HttpMethods.Put,
    ...params,
  });

export const addAthenaPatientInsurance = (patientId, params) =>
  restRequest({
    uri: `athena/patients/${patientId}/insurance`,
    method: HttpMethods.Post,
    ...params,
  });

export const subscribeToAppointmentChanges = (body, params) =>
  restRequest({
    uri: 'athena/appointments/changed/subscription',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const verifyAppointmentSubscription = (query, params) =>
  restRequest({
    uri: 'athena/appointments/changed/subscription',
    method: HttpMethods.Get,
    query,
    ...params,
  });

export const getChangedAppointments = (query, params) =>
  restRequest({
    uri: 'athena/appointments/changed',
    method: HttpMethods.Get,
    query,
    ...params,
  });
